module.exports = __webpack_public_path__ + "static/media/blood-diseases.a3277505.svg";